"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const light_1 = require("./light");
// prettier-ignore
exports.theme = {
    ...light_1.theme,
    light: false,
    scales: {
        //   bg-1  bg-2  el-1  el-2  el-3  bd-1  bd-2  bd-3  sol-1 sol-2 txt-1 txt-2
        L: [9, 12, 16, 20, 24, 32, 38, 44, 52, 58, 76, 88],
        xS: light_1.theme.scales.xS,
        dH: light_1.theme.scales.dH,
    },
    mapping: {
        bg: ['neutral', 0, 0, { L: 9 }],
    },
};
